<template>
  <div class="cart-popup__dialog">
    <TripleEyeHeader />

    <!-- 02_check-1 -->
    <div class="cart-popup__content height-auto" v-if="showPage === 1">
      <div class="content_eyecare">
        <div>
          <p class="eyecare_tit">
            <b class="color_orange">2. 나의 안구건조증 정도는?</b>
          </p>
          <p class="eyecare_txt2">다음의 12가지 질문을 통해 눈의 건조함 정도를 확인해보세요.</p>
          <p class="eyecare_txt color_black"><ins style="text-decoration:underline">지난주에</ins> 아래의 증상을 얼마나 자주 겪으셨나요?</p>

          <table class="eyecare_table">
            <caption>질문에 대한 5단계(항상, 매우자주, 자주, 가끔, 없음) 답변</caption>
            <thead>
              <tr>
                <th scope="col"><p class="hide">질문</p></th>
                <th scope="col">항상</th>
                <th scope="col">매우<br>자주</th>
                <th scope="col">자주</th>
                <th scope="col">가끔</th>
                <th scope="col">해당<br>없음</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1. 빛을 볼 때 예전보다 눈이 예민하고 불편하다</th>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question01" class="amw-global-radio" @click="selectedScore[0] = 4">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question01" class="amw-global-radio" @click="selectedScore[0] = 3">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question01" class="amw-global-radio" @click="selectedScore[0] = 2">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question01" class="amw-global-radio" @click="selectedScore[0] = 1">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question01" class="amw-global-radio" @click="selectedScore[0] = 0">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
              </tr>

              <tr>
                <th scope="row">2. 눈에 모래가 들어간 것 같은 느낌이 든다</th>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question02" class="amw-global-radio" @click="selectedScore[1] = 4">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question02" class="amw-global-radio" @click="selectedScore[1] = 3">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question02" class="amw-global-radio" @click="selectedScore[1] = 2">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question02" class="amw-global-radio" @click="selectedScore[1] = 1">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question02" class="amw-global-radio" @click="selectedScore[1] = 0">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
              </tr>

              <tr>
                <th scope="row">3. 눈에 통증이 있거나 쑤신다</th>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question03" class="amw-global-radio" @click="selectedScore[2] = 4">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question03" class="amw-global-radio" @click="selectedScore[2] = 3">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question03" class="amw-global-radio" @click="selectedScore[2] = 2">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question03" class="amw-global-radio" @click="selectedScore[2] = 1">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question03" class="amw-global-radio" @click="selectedScore[2] = 0">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
              </tr>

              <tr>
                <th scope="row">4. 시야가 흐리거나 뿌옇다</th>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question04" class="amw-global-radio" @click="selectedScore[3] = 4">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question04" class="amw-global-radio" @click="selectedScore[3] = 3">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question04" class="amw-global-radio" @click="selectedScore[3] = 2">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question04" class="amw-global-radio" @click="selectedScore[3] = 1">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question04" class="amw-global-radio" @click="selectedScore[3] = 0">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
              </tr>

              <tr>
                <th scope="row">5. 시력이 나빠져 이전보다 잘 보이지 않는다</th>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question05" class="amw-global-radio" @click="selectedScore[4] = 4">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question05" class="amw-global-radio" @click="selectedScore[4] = 3">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question05" class="amw-global-radio" @click="selectedScore[4] = 2">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question05" class="amw-global-radio" @click="selectedScore[4] = 1">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="amway-theme txtC">
                    <span class="amw-radio-wrap radio-label txtC focus">
                      <input type="radio" name="question05" class="amw-global-radio" @click="selectedScore[4] = 0">
                      <span class="amw-radio-overlay txtC"></span>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <p class="eyecare_comment">
            출처 : Ocular surface disease index(OSDI). Arch Ophthalmol.
            2000 May;118(5):615-21.<br>
            “본 자가진단은 증상의 조기발견을 도와 주기 위한 것으로,
            정확한 진단을 위해서는 의사와 상담이 필요합니다.”
          </p>
        </div>
        <p style="color:#ccc;font-size:9px;text-align:right">CN001953</p>
      </div>
    </div>
    <div class="cart-popup__item-link" v-if="showPage === 1">
      <button type="button" class="bt-akl-blue bt-eyecare-pop-orange" @click="nextQuest(1)">다음으로</button>
    </div>
    <!-- //02_check-1 -->

    <!-- 02_check-2 -->
      <div class="cart-popup__content height-auto" v-if="showPage === 2">
        <div class="content_eyecare">
          <div>
            <p class="eyecare_tit">
              <b class="color_orange">2. 나의 안구건조증 정도는?</b>
            </p>
            <p class="eyecare_txt2">다음의 12가지 질문을 통해 눈의 건조함 정도를 확인해보세요.<br> 답변 중 ‘해당 없음’은 지난주에 해당 활동이나 상황이 아예 없었을 때를 말합니다.</p>
            <p class="eyecare_txt color_black"><ins style="text-decoration:underline">지난주에</ins> 아래의 활동을 할 때 눈의 문제로 활동에 제한이 얼마나 자주 있으셨나요?</p>

            <table class="eyecare_table">
              <caption>질문에 대한 5단계(항상, 매우자주, 자주, 가끔, 없음) 답변</caption>
              <thead>
                <tr>
                  <th scope="col"><p class="hide">질문</p></th>
                  <th scope="col">항상</th>
                  <th scope="col">매우<br>자주</th>
                  <th scope="col">자주</th>
                  <th scope="col">가끔</th>
                  <th scope="col">없음</th>
                  <th scope="col">해당<br>없음</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">6. 책이나 신문을 볼 때</th>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question06" class="amw-global-radio" @click="selectedScore[5] = 4">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question06" class="amw-global-radio" @click="selectedScore[5] = 3">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question06" class="amw-global-radio" @click="selectedScore[5] = 2">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question06" class="amw-global-radio" @click="selectedScore[5] = 1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question06" class="amw-global-radio" @click="selectedScore[5] = 0">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question06" class="amw-global-radio" @click="selectedScore[5] = -1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th scope="row">7. 밤에 운전할 때</th>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question07" class="amw-global-radio" @click="selectedScore[6] = 4">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question07" class="amw-global-radio" @click="selectedScore[6] = 3">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question07" class="amw-global-radio" @click="selectedScore[6] = 2">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question07" class="amw-global-radio" @click="selectedScore[6] = 1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question07" class="amw-global-radio" @click="selectedScore[6] = 0">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question07" class="amw-global-radio" @click="selectedScore[6] = -1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th scope="row">8. 컴퓨터나 ATM 기기를 볼 때</th>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question08" class="amw-global-radio" @click="selectedScore[7] = 4">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question08" class="amw-global-radio" @click="selectedScore[7] = 3">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question08" class="amw-global-radio" @click="selectedScore[7] = 2">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question08" class="amw-global-radio" @click="selectedScore[7] = 1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question08" class="amw-global-radio" @click="selectedScore[7] = 0">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question08" class="amw-global-radio" @click="selectedScore[7] = -1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th scope="row">9. TV를 볼 때</th>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question09" class="amw-global-radio" @click="selectedScore[8] = 4">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question09" class="amw-global-radio" @click="selectedScore[8] = 3">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question09" class="amw-global-radio" @click="selectedScore[8] = 2">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question09" class="amw-global-radio" @click="selectedScore[8] = 1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question09" class="amw-global-radio" @click="selectedScore[8] = 0">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question09" class="amw-global-radio" @click="selectedScore[8] = -1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <p class="eyecare_comment">
              출처 : Ocular surface disease index(OSDI). Arch Ophthalmol.
              2000 May;118(5):615-21.<br>
              “본 자가진단은 증상의 조기발견을 도와 주기 위한 것으로,
              정확한 진단을 위해서는 의사와 상담이 필요합니다.”
            </p>
          </div>
          <p style="color:#ccc;font-size:9px;text-align:right">CN001953</p>
        </div>
      </div>
      <div class="cart-popup__item-link" v-if="showPage === 2">
        <button type="button" class="bt-akl-blue bt-eyecare-pop-orange" @click="nextQuest(2)">다음으로</button>
      </div>
      <!-- //02_check-2 -->

      <!-- 02_check-3 -->
      <div class="cart-popup__content height-auto" v-if="showPage === 3">
        <div class="content_eyecare">
          <div>
            <p class="eyecare_tit">
              <b class="color_orange">2. 나의 안구건조증 정도는?</b>
            </p>
            <p class="eyecare_txt2">다음의 12가지 질문을 통해 눈의 건조함 정도를 확인해보세요.<br> 답변 중 ‘해당 없음’은 지난주에 해당 활동이나 상황이 아예 없었을 때를 말합니다.</p>
            <p class="eyecare_txt color_black"><ins style="text-decoration:underline">지난주에</ins> 아래의 상황에서 눈에 불편함을 얼마나 자주 느끼셨나요?</p>

            <table class="eyecare_table">
              <caption>질문에 대한 5단계(항상, 매우자주, 자주, 가끔, 없음) 답변</caption>
              <thead>
                <tr>
                  <th scope="col"><p class="hide">질문</p></th>
                  <th scope="col">항상</th>
                  <th scope="col">매우<br>자주</th>
                  <th scope="col">자주</th>
                  <th scope="col">가끔</th>
                  <th scope="col">없음</th>
                  <th scope="col">해당<br>없음</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">10. 바람이 불 때</th>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question10" class="amw-global-radio" @click="selectedScore[9] = 4">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question10" class="amw-global-radio" @click="selectedScore[9] = 3">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question10" class="amw-global-radio" @click="selectedScore[9] = 2">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question10" class="amw-global-radio" @click="selectedScore[9] = 1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question10" class="amw-global-radio" @click="selectedScore[9] = 0">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question10" class="amw-global-radio" @click="selectedScore[9] = -1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th scope="row">11. 습도가 낮은 건조한 곳에 있을 때</th>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question11" class="amw-global-radio" @click="selectedScore[10] = 4">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question11" class="amw-global-radio" @click="selectedScore[10] = 3">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question11" class="amw-global-radio" @click="selectedScore[10] = 2">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question11" class="amw-global-radio" @click="selectedScore[10] = 1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question11" class="amw-global-radio" @click="selectedScore[10] = 0">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question11" class="amw-global-radio" @click="selectedScore[10] = -1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th scope="row">12. 히터/에어컨을 켜 놓았을 때</th>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question12" class="amw-global-radio" @click="selectedScore[11] = 4">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question12" class="amw-global-radio" @click="selectedScore[11] = 3">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question12" class="amw-global-radio" @click="selectedScore[11] = 2">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question12" class="amw-global-radio" @click="selectedScore[11] = 1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question12" class="amw-global-radio" @click="selectedScore[11] = 0">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="amway-theme txtC">
                      <span class="amw-radio-wrap radio-label txtC focus">
                        <input type="radio" name="question12" class="amw-global-radio" @click="selectedScore[11] = -1">
                        <span class="amw-radio-overlay txtC"></span>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <p class="eyecare_comment">
              출처 : Ocular surface disease index(OSDI). Arch Ophthalmol.
              2000 May;118(5):615-21.<br>
              “본 자가진단은 증상의 조기발견을 도와 주기 위한 것으로,
              정확한 진단을 위해서는 의사와 상담이 필요합니다.”
            </p>
          </div>
          <p style="color:#ccc;font-size:9px;text-align:right">CN001953</p>
        </div>
      </div>
      <div class="cart-popup__item-link" v-if="showPage === 3">
        <button type="button" class="bt-akl-blue bt-eyecare-pop-orange" @click="nextQuest(3)">결과보기</button>
      </div>
      <!-- //02_check-3 -->
  </div>
</template>

<script>
import TripleEyeHeader from './header.vue'

export default {
  name: 'TripleQuest2',
  components: {
    TripleEyeHeader
  },
  props: ['selectedScore'],
  data () {
    return {
      showPage: Number,
      validArr: [5, 9, 12]
    }
  },
  methods: {
    init: function () {
      this.showPage = 1
    },
    rdClick () {
      console.log(this.selectedScore[0])
    },
    nextQuest (page) {
      if (this.validationCheck(page)) {
        if (page === 3) this.$emit('clickNext') // 결과보기 페이지
        else this.showPage = page + 1 // 다음 질문
      } else {
        alert('모든 문항에 응답해주세요')
      }
    },
    validationCheck (page) {
      let validResult = true // 검증결과
      let checkArr = this.selectedScore.slice(0, this.validArr[page - 1]) // 검증대상 복사

      checkArr.forEach(element => { // 대상 루프
        if (!element && element !== 0) { // 값이 없는 대상 처리
          validResult = false
        }
      })
      return validResult
    }
  },
  mounted: function () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/triple-eye-care/component/quest2.vue